import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import useStyles from "./style.js";

function Contactzone(props) {
  const classes = useStyles();
  const { google } = props;
  return (
    <Grid className={classes.root}>
      <Container maxWidth="xl" className={classes.container}>
        <Map
          google={google}
          zoom={16}
          style={{ height: "400px", position: "relative" }}
          initialCenter={{ lat: 4.637608375012955, lng: -74.06252343155685 }}
          containerStyle={{
            position: "relative",
            width: "100%",
            height: "100%",
          }} >
          <Marker
            position={{ lat: 4.637608375012955, lng: -74.06252343155685 }}
            name={"Current location"}
          />
        </Map>
      </Container>
    </Grid>
  );
}

export default GoogleApiWrapper({
  apiKey: process.env.API_KEY_GOOGLEMAPS,
})(Contactzone); 